import { createApp } from 'vue';
import EditHikeDetailsApp from './EditHikeDetailsApp.vue';
import { i18n } from '../../i18n';

// Only mounts when the owner-gated mount point is present on the page.
const el = document.getElementById('edit-hike-details');
if (el) {
  createApp(EditHikeDetailsApp).use(i18n).mount('#edit-hike-details');
}
